"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const raz_resume_1 = require("./raz-resume");
require("./App.css");
// ─── Helpers ──────────────────────────────────────────────────────────────────
function formatDate(d) {
    if (!d)
        return '';
    const parts = d.split('-');
    if (parts.length < 2)
        return parts[0];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${months[parseInt(parts[1], 10) - 1]} ${parts[0]}`;
}
function getYear(d) {
    return d ? d.split('-')[0] : '';
}
function isCurrent(endDate) {
    return !endDate;
}
// Heuristic: highlights with ≤3 spaces are tags (short phrases/tech names)
function isTag(s) {
    return (s.match(/ /g) || []).length <= 3;
}
function levelLabel(n) {
    if (n >= 90)
        return 'Master';
    if (n >= 80)
        return 'Expert';
    if (n >= 70)
        return 'Advanced';
    if (n >= 60)
        return 'Proficient';
    if (n >= 50)
        return 'Intermediate';
    if (n >= 40)
        return 'Competent';
    return 'Foundational';
}
function levelClass(n) {
    return levelLabel(n).toLowerCase();
}
function groupBy(arr, key) {
    return arr.reduce((acc, item) => {
        const k = key(item);
        if (!acc[k])
            acc[k] = [];
        acc[k].push(item);
        return acc;
    }, {});
}
// ─── Icons ────────────────────────────────────────────────────────────────────
const IconGitHub = () => (react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" },
    react_1.default.createElement("path", { d: "M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" })));
const IconLinkedIn = () => (react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" },
    react_1.default.createElement("path", { d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" })));
const IconTwitter = () => (react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" },
    react_1.default.createElement("path", { d: "M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" })));
const IconEmail = () => (react_1.default.createElement("svg", { width: "13", height: "13", viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" },
    react_1.default.createElement("path", { d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" })));
const IconPhone = () => (react_1.default.createElement("svg", { width: "13", height: "13", viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" },
    react_1.default.createElement("path", { d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" })));
const IconLocation = () => (react_1.default.createElement("svg", { width: "13", height: "13", viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" },
    react_1.default.createElement("path", { d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" })));
const IconLink = () => (react_1.default.createElement("svg", { width: "13", height: "13", viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" },
    react_1.default.createElement("path", { d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" })));
const IconDownload = () => (react_1.default.createElement("svg", { width: "13", height: "13", viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true" },
    react_1.default.createElement("path", { d: "M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z" })));
function NetworkIcon({ network }) {
    switch (network.toLowerCase()) {
        case 'github': return react_1.default.createElement(IconGitHub, null);
        case 'linkedin': return react_1.default.createElement(IconLinkedIn, null);
        case 'twitter': return react_1.default.createElement(IconTwitter, null);
        default: return react_1.default.createElement(IconLink, null);
    }
}
// ─── Sidebar ──────────────────────────────────────────────────────────────────
function Sidebar({ basics, languages, interests }) {
    const blogUrl = '/blog/';
    const resumePdfUrl = '/mehraz-ali-resume.pdf';
    return (react_1.default.createElement("aside", { className: "sidebar" },
        react_1.default.createElement("div", { className: "sidebar__profile" },
            basics.picture && (react_1.default.createElement("div", { className: "avatar" },
                react_1.default.createElement("img", { src: basics.picture, alt: basics.name }))),
            react_1.default.createElement("h1", { className: "sidebar__name" }, basics.name),
            react_1.default.createElement("p", { className: "sidebar__label" }, basics.label)),
        react_1.default.createElement("div", { className: "sidebar__block" },
            react_1.default.createElement("a", { href: `mailto:${basics.email}`, className: "contact-row" },
                react_1.default.createElement(IconEmail, null),
                react_1.default.createElement("span", null, basics.email)),
            react_1.default.createElement("a", { href: `tel:${basics.phone}`, className: "contact-row" },
                react_1.default.createElement(IconPhone, null),
                react_1.default.createElement("span", null, basics.phone)),
            react_1.default.createElement("div", { className: "contact-row" },
                react_1.default.createElement(IconLocation, null),
                react_1.default.createElement("span", null,
                    basics.location.city,
                    ", ",
                    basics.location.region)),
            react_1.default.createElement("a", { href: basics.website, className: "contact-row", target: "_blank", rel: "noopener noreferrer" },
                react_1.default.createElement(IconLink, null),
                react_1.default.createElement("span", null, basics.website.replace(/^https?:\/\//, ''))),
            react_1.default.createElement("a", { href: blogUrl, className: "contact-row" },
                react_1.default.createElement(IconLink, null),
                react_1.default.createElement("span", null, "mehrazali.com/blog/")),
            react_1.default.createElement("a", { href: resumePdfUrl, className: "contact-row", download: true },
                react_1.default.createElement(IconDownload, null),
                react_1.default.createElement("span", null, "Download resume PDF"))),
        react_1.default.createElement("div", { className: "sidebar__block" }, basics.profiles.map(p => (react_1.default.createElement("a", { key: p.network, href: p.url, className: "profile-row", target: "_blank", rel: "noopener noreferrer" },
            react_1.default.createElement(NetworkIcon, { network: p.network }),
            react_1.default.createElement("span", null, p.username))))),
        react_1.default.createElement("nav", { className: "sidebar__nav" },
            react_1.default.createElement("a", { href: "#experience", className: "nav-link" }, "Experience"),
            react_1.default.createElement("a", { href: "#skills", className: "nav-link" }, "Skills"),
            react_1.default.createElement("a", { href: "#education", className: "nav-link" }, "Education"),
            react_1.default.createElement("a", { href: "#volunteer", className: "nav-link" }, "Volunteer"),
            react_1.default.createElement("a", { href: blogUrl, className: "nav-link" }, "Blog"),
            react_1.default.createElement("a", { href: resumePdfUrl, className: "nav-link", download: true }, "PDF")),
        react_1.default.createElement("div", { className: "sidebar__block" },
            react_1.default.createElement("p", { className: "sidebar__label--section" }, "Languages"),
            react_1.default.createElement("div", { className: "lang-list" }, languages.map(l => (react_1.default.createElement("div", { key: l.name, className: "lang-row" },
                react_1.default.createElement("span", { className: "lang-name" }, l.name),
                react_1.default.createElement("span", { className: "lang-level" }, l.level)))))),
        react_1.default.createElement("div", { className: "sidebar__block" },
            react_1.default.createElement("p", { className: "sidebar__label--section" }, "Interests"),
            react_1.default.createElement("div", { className: "interest-cloud" }, interests.map(i => (react_1.default.createElement("span", { key: i.name, className: "interest-pill" }, i.name)))))));
}
// ─── Section Header ───────────────────────────────────────────────────────────
function SectionHead({ num, title, id }) {
    return (react_1.default.createElement("div", { className: "section-head", id: id },
        react_1.default.createElement("span", { className: "section-num" }, num),
        react_1.default.createElement("h2", { className: "section-title" }, title),
        react_1.default.createElement("div", { className: "section-rule" })));
}
// ─── Work Card ────────────────────────────────────────────────────────────────
function WorkCard({ item, index }) {
    const tags = item.highlights.filter(isTag);
    const bullets = item.highlights.filter(h => !isTag(h));
    const current = isCurrent(item.endDate);
    return (react_1.default.createElement("article", { className: `work-card${current ? ' work-card--active' : ''}`, style: { animationDelay: `${index * 50}ms` } },
        react_1.default.createElement("div", { className: "work-card__rail" },
            react_1.default.createElement("div", { className: "work-card__dot" }),
            react_1.default.createElement("div", { className: "work-card__stem" })),
        react_1.default.createElement("div", { className: "work-card__content" },
            react_1.default.createElement("div", { className: "work-card__meta" },
                react_1.default.createElement("span", { className: "work-card__dates" },
                    formatDate(item.startDate),
                    ' ',
                    "\u2014",
                    ' ',
                    current ? react_1.default.createElement("span", { className: "date-now" }, "Present") : formatDate(item.endDate)),
                current && react_1.default.createElement("span", { className: "badge-active" }, "Active")),
            react_1.default.createElement("h3", { className: "work-card__position" }, item.position),
            item.website ? (react_1.default.createElement("a", { className: "work-card__company", href: item.website, target: "_blank", rel: "noopener noreferrer" },
                item.company,
                "\u00A0\u2197")) : (react_1.default.createElement("span", { className: "work-card__company work-card__company--plain" }, item.company)),
            react_1.default.createElement("p", { className: "work-card__summary" }, item.summary),
            bullets.length > 0 && (react_1.default.createElement("ul", { className: "work-card__bullets" }, bullets.map((b, i) => react_1.default.createElement("li", { key: i }, b)))),
            tags.length > 0 && (react_1.default.createElement("div", { className: "tag-row" }, tags.map((t, i) => react_1.default.createElement("span", { key: i, className: "tag" }, t)))))));
}
// ─── Skills ───────────────────────────────────────────────────────────────────
function TechSkillCloud({ skills }) {
    const sorted = [...skills].sort((a, b) => b.level - a.level);
    return (react_1.default.createElement("div", { className: "tech-cloud" }, sorted.map(s => (react_1.default.createElement("span", { key: s.name, className: `tech-pill tech-pill--${levelClass(s.level)}`, title: `${levelLabel(s.level)} (${s.level}%)` }, s.name)))));
}
function SkillBars({ skills }) {
    const sorted = [...skills].sort((a, b) => b.level - a.level);
    return (react_1.default.createElement("div", { className: "skill-bars" }, sorted.map(s => (react_1.default.createElement("div", { key: s.name, className: "skill-bar" },
        react_1.default.createElement("div", { className: "skill-bar__label" },
            react_1.default.createElement("span", { className: "skill-bar__name" }, s.name),
            react_1.default.createElement("span", { className: `skill-bar__badge skill-bar__badge--${levelClass(s.level)}` }, levelLabel(s.level))),
        react_1.default.createElement("div", { className: "skill-bar__track" },
            react_1.default.createElement("div", { className: "skill-bar__fill", style: { width: `${s.level}%` } })))))));
}
// ─── Education ────────────────────────────────────────────────────────────────
function EduCard({ edu }) {
    return (react_1.default.createElement("div", { className: "edu-card" },
        react_1.default.createElement("div", { className: "edu-card__years" },
            getYear(edu.startDate),
            " \u2014 ",
            getYear(edu.endDate)),
        react_1.default.createElement("div", { className: "edu-card__body" },
            react_1.default.createElement("h3", { className: "edu-card__institution" }, edu.institution),
            react_1.default.createElement("p", { className: "edu-card__degree" }, edu.studyType),
            react_1.default.createElement("p", { className: "edu-card__area" }, edu.area),
            edu.gpa && react_1.default.createElement("p", { className: "edu-card__gpa" },
                "GPA ",
                edu.gpa))));
}
// ─── Volunteer ────────────────────────────────────────────────────────────────
function VolCard({ item }) {
    return (react_1.default.createElement("div", { className: "vol-card" },
        react_1.default.createElement("h4", { className: "vol-card__org" }, item.website
            ? react_1.default.createElement("a", { href: item.website, target: "_blank", rel: "noopener noreferrer" }, item.organization)
            : item.organization),
        react_1.default.createElement("span", { className: "vol-card__role" }, item.position),
        item.summary && react_1.default.createElement("p", { className: "vol-card__summary" }, item.summary),
        item.highlights && item.highlights.filter(Boolean).map((h, i) => (react_1.default.createElement("p", { key: i, className: "vol-card__note" }, h)))));
}
// ─── App ──────────────────────────────────────────────────────────────────────
class App extends react_1.default.Component {
    render() {
        const data = raz_resume_1.raz;
        const basics = data.basics;
        const work = data.work;
        const skills = data.skills;
        const education = data.education;
        const volunteer = data.volunteer;
        const languages = data.languages;
        const interests = data.interests;
        const skillsByCategory = groupBy(skills, s => (s.keywords && s.keywords[0]) || 'Other');
        const techSkills = skillsByCategory['Technical'] || [];
        const consultingSkills = skillsByCategory['Consulting'] || [];
        const testingSkills = skillsByCategory['Testing'] || [];
        const domainSkills = skillsByCategory['Domain'] || [];
        return (react_1.default.createElement("div", { className: "resume" },
            react_1.default.createElement(Sidebar, { basics: basics, languages: languages, interests: interests }),
            react_1.default.createElement("main", { className: "main" },
                react_1.default.createElement("section", { className: "section section--intro" },
                    react_1.default.createElement("div", { className: "intro-summary" },
                        react_1.default.createElement("p", null, basics.summary))),
                react_1.default.createElement("section", { className: "section", id: "experience" },
                    react_1.default.createElement(SectionHead, { num: "01", title: "Experience", id: "experience-head" }),
                    react_1.default.createElement("div", { className: "work-timeline" }, work.map((item, i) => react_1.default.createElement(WorkCard, { key: i, item: item, index: i })))),
                react_1.default.createElement("section", { className: "section", id: "skills" },
                    react_1.default.createElement(SectionHead, { num: "02", title: "Skills", id: "skills-head" }),
                    techSkills.length > 0 && (react_1.default.createElement("div", { className: "skills-block" },
                        react_1.default.createElement("p", { className: "skills-block__label" }, "Technical"),
                        react_1.default.createElement(TechSkillCloud, { skills: techSkills }))),
                    react_1.default.createElement("div", { className: "skills-columns" },
                        consultingSkills.length > 0 && (react_1.default.createElement("div", { className: "skills-column" },
                            react_1.default.createElement("p", { className: "skills-block__label" }, "Leadership & Consulting"),
                            react_1.default.createElement(SkillBars, { skills: consultingSkills }))),
                        testingSkills.length > 0 && (react_1.default.createElement("div", { className: "skills-column" },
                            react_1.default.createElement("p", { className: "skills-block__label" }, "Quality & Testing"),
                            react_1.default.createElement(SkillBars, { skills: testingSkills }))),
                        domainSkills.length > 0 && (react_1.default.createElement("div", { className: "skills-column" },
                            react_1.default.createElement("p", { className: "skills-block__label" }, "Domain Expertise"),
                            react_1.default.createElement(SkillBars, { skills: domainSkills }))))),
                react_1.default.createElement("section", { className: "section", id: "education" },
                    react_1.default.createElement(SectionHead, { num: "03", title: "Education", id: "education-head" }),
                    react_1.default.createElement("div", { className: "edu-list" }, education.map((e, i) => react_1.default.createElement(EduCard, { key: i, edu: e })))),
                react_1.default.createElement("section", { className: "section", id: "volunteer" },
                    react_1.default.createElement(SectionHead, { num: "04", title: "Community", id: "volunteer-head" }),
                    react_1.default.createElement("div", { className: "vol-grid" }, volunteer.map((v, i) => react_1.default.createElement(VolCard, { key: i, item: v })))))));
    }
}
exports.default = App;



// WEBPACK FOOTER //
// ./src/App.js